<template>
  <div class="reward-page">
    <div class="top-bg"></div>

    <div class="top-info">
      <div class="title">交易即送奖励</div>
      <div class="sub-title">开始您的交易活动</div>
    </div>

    <div class="reward-list">
      <div class="title">交易任务</div>

      <div class="reward-box">
        <div class="sub-title">期权交易</div>
        <div class="flex">
          <div class="flex-1 flex-column-center" :class="item.status == 1 ? 'active' : ''" v-for="(item, i) in rewardList1" :key="i">
            <div class="count">+{{item.RewardAmount}}USDT</div>
            <div class="icon">
              <img :src="coinUrl" alt="" v-if="item.status != 1">
              <img :src="coinUrl2" alt="" v-else>
            </div>
            <div class="line"></div>
            <div class="label">交易</div>
            <div class="number">{{item.TradeVolume}} USDT</div>
          </div>
        </div>
      </div>

      <div class="reward-box">
        <div class="sub-title">合约交易</div>
        <div class="flex">
          <div class="flex-1 flex-column-center" :class="item.status == 1 ? 'active' : ''" v-for="(item, i) in rewardList2" :key="i">
            <div class="count">+{{item.RewardAmount}}USDT</div>
            <div class="icon">
              <img :src="coinUrl" alt="" v-if="item.status != 1">
              <img :src="coinUrl2" alt="" v-else>
            </div>
            <div class="line"></div>
            <div class="label">交易</div>
            <div class="number">{{item.TradeVolume}} USDT</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 奖励详情按钮 -->
    <div class="detail-button-container">
      <button class="detail-button" @click="goToRewardDetail">
        {{$t('reward.viewDetail')}}
      </button>
    </div>

  </div>
</template>
<script>
import { rewardList, rewardLog } from '@/api/index'
import moment from 'moment'
export default {
  components: {
  },
  data() {
    return {
      coinUrl: require('../../assets/imgs/icon-coin.png'),
      coinUrl2: require('../../assets/imgs/icon-coin2.png'),
      isInit: false,
      finishedText: '',
      rewardList1: [],
      rewardList2: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    init() {
      let form = new FormData()
      form.append('Start', moment().format('YYYY-MM-DD') + ' 00:00:00')
      rewardLog(form).then(res => {
        this.isLogInit = true
        this.logList = res.data.Items
        if (this.isListInit) {
          this.resetData()
        }
      })


      let form2 = new FormData()
      form2.append('pageSize', 30)
      rewardList(form2).then(res => {
        let list = res.data.Items
        this.isListInit = true
        this.rewardList1 = list.filter(v => {
          return v.TradeType == 'option'
        }).sort((a, b) => {
          return a.TradeVolume - b.TradeVolume
        })
        this.rewardList2 = list.filter(v => {
          return v.TradeType == 'contract'
        }).sort((a, b) => {
          return a.TradeVolume - b.TradeVolume
        })
        if (this.isLogInit) {
          this.resetData()
        }
      })
    },
    resetData() {
      this.rewardList1.forEach(v => {
        let index = this.logList.findIndex(val => {
          return v.ID == val.RewardSettingsID
        })
        if (index > -1) {
          v.statue = 1
        }
      })
      this.rewardList2.forEach(v => {
        let index = this.logList.findIndex(val => {
          return v.ID == val.RewardSettingsID
        })
        if (index > -1) {
          v.statue = 1
        }
      })
    },
    goToRewardDetail() {
      this.$router.push({ name: 'rewardDetail' })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-button-container {
  margin-top: 40px;
  padding: 0 40px;
  display: flex;
  justify-content: center;
}

.detail-button {
  background: linear-gradient(90deg, #FFD700 0%, #FFA500 100%);
  color: #000000;
  border: none;
  border-radius: 30px;
  padding: 15px 40px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(255, 215, 0, 0.3);
  min-width: 200px;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.4);
    background: linear-gradient(90deg, #FFA500 0%, #FFD700 100%);
  }

  &:active {
    transform: translateY(-1px);
  }
}
</style>